import jwt from 'jwt-simple'

const ID_TOKEN_KEY = 'analiticatoken'
const SECRET_KEY = 'acr[aaa@3·'

export default {
	getToken () {
		return window.localStorage.getItem(ID_TOKEN_KEY)
	},
	getTokenApp(){
		return jwt.encode(ID_TOKEN_KEY, SECRET_KEY, 'HS256');
	},
	setEncode(payload){
		return jwt.encode(payload, SECRET_KEY);
	},
	getDecode(token){
		return jwt.decode(token, SECRET_KEY);
	},
	saveToken (token) {
		window.localStorage.setItem(ID_TOKEN_KEY, token)
	},
	destroyToken () {
		window.localStorage.removeItem(ID_TOKEN_KEY)
	}
}


// WEBPACK FOOTER //
// ./src/common/jwt.service.js